import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { getWindowOrThrow } from "../../globals/getWindow";
import { isElementPartiallyInViewport } from "./isElementInViewport";
export var getFaireImageIdentifier = function(target) {
    return target.getAttribute("data-faire-image-id") || target.srcset || target.src;
};
export var getSetOfImageIdentifiers = function(targetElements, shouldIncludeAllImages) {
    var _instance;
    var window = getWindowOrThrow();
    var windowHeight = window.innerHeight;
    var windowWidth = window.innerWidth;
    var isImageVisible = function(img) {
        if (!img.complete && isElementPartiallyInViewport(img, windowHeight, windowWidth)) {
            var style = window.getComputedStyle(img);
            return style.visibility !== "hidden";
        }
        return false;
    };
    var imgs = (_instance = new Array()).concat.apply(_instance, _to_consumable_array(targetElements.map(function(element) {
        return Array.from(element.querySelectorAll("img"));
    }))).filter(function(img) {
        return !img.src.startsWith("data:");
    });
    return {
        numImages: imgs.length,
        pendingImageUrls: new Set((shouldIncludeAllImages ? imgs : imgs.filter(isImageVisible)).map(function(img) {
            return getFaireImageIdentifier(img);
        }))
    };
};
